module.exports = __webpack_public_path__ + "media/AUDIO-06.36ee7304.mp3";